import React from 'react'
import Classes from '../../Integrations.module.css'

export default function Sidebar({ activeTab, setActiveTab }) {
    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "all" ? Classes.active : ""}
                onClick={() => setActiveTab("all")}>
                <h5>All</h5>
            </li>

            <li className={activeTab === "payment" ? Classes.active : ""}
                onClick={() => setActiveTab("payment")}>
                <h5>Payment</h5>
            </li>

            <li className={activeTab === "messaging" ? Classes.active : ""}
                onClick={() => setActiveTab("messaging")}>
                <h5>Messaging</h5>
            </li>

            <li className={activeTab === "email" ? Classes.active : ""}
                onClick={() => setActiveTab("email")}>
                <h5>Email</h5>
            </li>
        </ul>
    )
}
